import React from 'react';
import './controls.scss';
import Loading from '../Loading';
//import { useNavigate } from 'react-router-dom';
import { useNavigate } from '../Navigate';

export const ButtonControl = ({
    to,
    field,
    value,
    type,
    onClick,
    onDoubleClick,
    className,
    disabled,
    loading,
    children,
    disabledTitle,
    props,
    ...buttonProps
}) => {

    const navigate = useNavigate();
    const idName = `field_btn_${(field?.FieldName ?? (value ?? (children ?? 'unknown')).replace(' ', '_'))}`;
    const buttonClassName = `btn_control__${type ?? 'standard'}`;
    const displayName = value ?? (field?.displayName ?? (value ?? (children ?? 'Submit')));
    const accessibleName = buttonProps['aria-label'] ?? props?.['aria-label'] ?? displayName;
    const handleOnClick = (e) => {
        switch (e.detail) {
            // detail is 0 for keyboard-triggered clicks (Enter/Space) and 1 for a mouse single-click;
            // both should behave like a single click/activation.
            case 0:
            case 1: {
                if (onClick) {
                    onClick(e, field?.FieldName)
                }
                else if (to) {
                    navigate(to);
                }
                break;
            }
            case 2: {
                if (onDoubleClick) {
                    onDoubleClick(e, field?.FieldName)
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    const disabledState = (disabled === true && !loading &&
        <button key={idName} type="button" title={disabledTitle ?? ''}
            className={`btn_control ${buttonClassName} ${className ?? ''}`}
            disabled {...props} {...buttonProps}>
            {displayName}
        </button>);

    const activeState = (!disabled && !loading && <button key={idName} type="button" onClick={handleOnClick} className={`btn_control ${buttonClassName} ${className ?? ''}`} {...props} {...buttonProps}>{displayName}</button>);
    const loadingState = (loading === true &&
        <button key={idName} type="button" className={`btn_control ${buttonClassName} ${className ?? ''}`} {...props} {...buttonProps} disabled aria-busy="true" aria-label={`Loading ${accessibleName}`}>
            <div className='inner_loading' aria-hidden="true"><Loading /></div>
            <div className='inner_loading_text' aria-hidden="true">{displayName}</div>
        </button>);

    return <>
        {activeState}
        {disabledState}
        {loadingState}
    </>
}

export default ButtonControl;